import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../ui/table';
import React from 'react';

type SimpleTableColumn<T> = {
  columnLabel: string;
  cellRenderer: (row: T) => React.ReactNode;
};

type SimpleTableProps<
  T extends {
    metadata: {
      id: string;
    };
  },
> = {
  columns: SimpleTableColumn<T>[];
  data: T[];
};

export function SimpleTable<
  T extends {
    metadata: {
      id: string;
    };
  },
>({ columns, data }: SimpleTableProps<T>) {
  return (
    <div className="overflow-auto rounded-md border bg-background">
      <Table>
        <TableHeader>
          <TableRow>
            {columns.map(({ columnLabel }) => (
              <TableHead key={columnLabel} className="pr-8">
                {columnLabel}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.metadata.id}>
              {columns.map(({ columnLabel, cellRenderer }) => (
                <TableCell key={columnLabel} className="pr-8">
                  {cellRenderer(row)}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
